import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("serenity_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super-admin brand targeting: send the selected brand so the backend scopes
  // admin reads/writes accordingly. Harmless for brand-locked admins (ignored server-side).
  const brand = localStorage.getItem("admin_brand");
  if (brand) config.headers["X-Brand"] = brand;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url?.includes("/auth/login") &&
      !original.url?.includes("/auth/refresh")
    ) {
      original._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(
            `${API}/auth/refresh`,
            {},
            {
              withCredentials: true,
              headers: { "X-Refresh-Token": localStorage.getItem("serenity_refresh") || "" },
            }
          );
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("serenity_token", data.access_token);
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("serenity_token");
        localStorage.removeItem("serenity_refresh");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
